import { useEffect } from 'react'
import { getAllTickets, addTicket, updateTicket, deleteTicket } from '../../../services/sTicket/ticket.service';

const useGetTickets = (tickets, setTickets) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getAllTickets();
                const response = serviceResponse.data;
                const aux = [];
                
                if (response.succeeded) {
                    response.data.forEach(element => {
                        const { id, subject, category, assignee, priority, status, update, creation_date, answers_number, has_docs } = element;
                        aux.push({ id, subject, category, assignee, priority, status, update, creation_date, answers_number, has_docs });                        
                    });
                }

                setTickets(aux);                
            }
            catch (error) {
                setTickets([]);
                console.log(error)
            }
        }
        
        if (tickets === null) {
            getData()
        }
    }, [tickets, setTickets]);
}


export {
    useGetTickets    
}